/**
 * Açılır sepet — hızlı Cart API + Section Rendering
 * wpbingo.js'ten önce yüklenir; window.CartDrawer ve window.loadMiniCart sağlar.
 */
(function (window, $) {
  'use strict';

  var SECTION_ID = 'mini-cart';
  var changeRequest = null;
  var lastShippingReached = null;
  var qtyDebounceMs = 280;

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function formatMoney(cents) {
    if (window.wpbingo && wpbingo.Currency && wpbingo.Currency.formatMoney) {
      return wpbingo.Currency.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function getCartContainers() {
    return {
      $drawer: $('.mini-cart [data-cart-container]'),
      $header: $('.header-cart [data-cart-container]')
    };
  }

  function parseSectionHtml(html) {
    var $temp = $('<div>').html(html);
    var $container = $temp.find('[data-cart-container]').first();
    return {
      $temp: $temp,
      $container: $container,
      $topBanners: $temp.find('.ajaxcart__top-banners'),
      priceShippingBar: $temp.find('.modacan-shipping-bar, .shipping-bar-cart').first().data('price_shipping_bar')
    };
  }

  function applyContainerHtml(html, opts) {
    opts = opts || {};
    var parsed = parseSectionHtml(html);
    var $new = parsed.$container;
    var targets = getCartContainers();
    var itemCount = $new.attr('data-item-count');

    if ($new.length) {
      if (targets.$drawer.length) {
        targets.$drawer.html($new.html());
        if (itemCount !== undefined) {
          targets.$drawer.attr('data-item-count', itemCount);
        }
        if (opts.loading === false) {
          targets.$drawer.removeClass('is-cart-loading');
        }
      }
      if (
        targets.$header.length &&
        window.wpbingo &&
        wpbingo.settings &&
        wpbingo.settings.cartType === 'modal'
      ) {
        targets.$header.html($new.html());
        if (itemCount !== undefined) {
          targets.$header.attr('data-item-count', itemCount);
        }
      }
    }

    if (typeof window.cartAction === 'function') {
      window.cartAction();
    }

    return parsed;
  }

  function persistCount(count) {
    try {
      sessionStorage.setItem('modacan_cart_count', String(count));
    } catch (e) {
      /* ignore */
    }
  }

  function updateCount(cart) {
    if (!cart) return;
    var count = cart.item_count;
    $('[data-cart-count]').html(count);
    persistCount(count);
    var targets = getCartContainers();
    if (targets.$drawer.length) {
      targets.$drawer.attr('data-item-count', count);
    }
    if (targets.$header.length) {
      targets.$header.attr('data-item-count', count);
    }
  }

  function sumOriginalLines(cart) {
    var total = 0;
    if (!cart.items) return total;
    for (var i = 0; i < cart.items.length; i++) {
      total += cart.items[i].original_line_price;
    }
    return total;
  }

  function updateFooter(cart) {
    if (!cart || !$('.ajaxcart__footer').length) return;

    $('.ajaxcart__subtotal').text(formatMoney(cart.total_price));

    var originalTotal = sumOriginalLines(cart);
    var $originalRow = $('.ajaxcart__footer-original');
    if (originalTotal > cart.total_price) {
      if ($originalRow.length) {
        $('.ajaxcart__subtotal--original').text(formatMoney(originalTotal));
      }
    } else {
      $originalRow.remove();
    }

    if (cart.total_discount > 0) {
      $('.ajaxcart__footer-discount .ajaxcart__price').text('-' + formatMoney(cart.total_discount));
    }
  }

  function updateLinePrice(cart, line) {
    var item = cart.items[line - 1];
    if (!item) return false;

    var $wrap = $('.item-cart[data-line="' + line + '"] .ajaxcart__product-price-wrapper');
    if (!$wrap.length) return false;

    var html;
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      html =
        '<del class="ajaxcart__price ajaxcart__price--regular">' +
        formatMoney(item.original_line_price) +
        '</del><span class="ajaxcart__price ajaxcart__price--sale">' +
        formatMoney(item.final_line_price) +
        '</span>';
    } else {
      html = '<span class="ajaxcart__price">' + formatMoney(item.final_line_price) + '</span>';
    }
    $wrap.html(html);
    return true;
  }

  function patchTopBanners(sectionHtml) {
    var parsed = parseSectionHtml(sectionHtml);
    if (parsed.$topBanners.length && $('.ajaxcart__top-banners').length) {
      $('.ajaxcart__top-banners').replaceWith(parsed.$topBanners.clone());
      return parsed.priceShippingBar;
    }
    return parsed.priceShippingBar;
  }

  function needsFullSection(prev, next) {
    if (!prev || !next) return true;
    if (prev.item_count !== next.item_count) return true;
    if (prev.total_discount !== next.total_discount) return true;
    if ((prev.total_discount > 0) !== (next.total_discount > 0)) return true;
    return false;
  }

  function shippingConfetti(cart, priceBar) {
    var threshold =
      priceBar ||
      $('.modacan-shipping-bar, .shipping-bar-cart').first().data('price_shipping_bar');
    if (!threshold || !cart) return;

    var reached = cart.total_price >= threshold;

    if (window.wpbingo && typeof wpbingo.updateShippingBar === 'function') {
      wpbingo.updateShippingBar(cart);
    }

    if (lastShippingReached === null) {
      lastShippingReached = reached;
      return;
    }

    if (!lastShippingReached && reached && typeof window.confettiLoop === 'function') {
      var $box = $('[data-cart-container]');
      if (!$box.hasClass('fire-done')) {
        $box.addClass('fire');
      }
      if ($box.hasClass('fire')) {
        $('#fire_work').removeClass('hide');
        confettiLoop();
      }
      setTimeout(function () {
        $box.addClass('fire-done').removeClass('fire');
      }, 1000);
      setTimeout(function () {
        $('#fire_work').addClass('hide');
      }, 5000);
    }

    if (!reached) {
      $('[data-cart-container]').removeClass('fire-done');
      $('#fire_work').addClass('hide');
    }

    lastShippingReached = reached;
  }

  function afterCart(cart, priceBar) {
    updateCount(cart);
    updateFooter(cart);
    shippingConfetti(cart, priceBar);
  }

  var CartDrawer = {
    open: function () {
      if ($('.mini-cart').hasClass('layout-drawer')) {
        $('body').addClass('drawer--open');
      }
    },

    close: function () {
      $('body').removeClass('drawer--open');
    },

    setLoading: function (on) {
      var targets = getCartContainers();
      var $c = targets.$drawer.add(targets.$header);
      if (on) {
        $c.addClass('is-cart-loading');
      } else {
        $c.removeClass('is-cart-loading');
      }
    },

    /** Header sayacını cart.js ile günceller (önbellekli sayfalarda Liquid 0 gösterebilir). */
    syncCount: function () {
      return $.getJSON('/cart.js')
        .then(function (cart) {
          updateCount(cart);
          return cart;
        })
        .fail(function () {
          try {
            var stored = sessionStorage.getItem('modacan_cart_count');
            if (stored !== null && $('[data-cart-count]').length) {
              $('[data-cart-count]').html(stored);
            }
          } catch (e) {
            /* ignore */
          }
        });
    },

    applySections: function (data) {
      if (data && data.sections && data.sections[SECTION_ID]) {
        applyContainerHtml(data.sections[SECTION_ID], { loading: false });
        return true;
      }
      return false;
    },

    refresh: function () {
      var self = this;
      self.setLoading(true);
      var sectionUrl =
        '/?sections=' +
        SECTION_ID +
        '&sections_url=' +
        encodeURIComponent(sectionsUrl());
      return $.getJSON(sectionUrl)
        .then(function (response) {
          var html = response[SECTION_ID];
          var parsed = applyContainerHtml(html, { loading: false });
          return $.getJSON('/cart.js').then(function (cart) {
            afterCart(cart, parsed.priceShippingBar);
            return cart;
          });
        })
        .always(function () {
          self.setLoading(false);
        });
    },

    change: function (line, quantity, prevCart) {
      var self = this;
      var $row = $('.item-cart[data-line="' + line + '"]');
      $row.addClass('is-loading');
      self.setLoading(true);

      if (changeRequest && changeRequest.abort) {
        changeRequest.abort();
      }

      var payload = {
        line: line,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: sectionsUrl()
      };

      changeRequest = $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        dataType: 'json'
      });

      return changeRequest
        .done(function (cart) {
          $row.removeClass('is-loading');
          self.setLoading(false);
          updateCount(cart);

          var sectionHtml = cart.sections && cart.sections[SECTION_ID];
          var fullRefresh =
            quantity === 0 ||
            cart.item_count === 0 ||
            needsFullSection(prevCart, cart);

          if (sectionHtml && fullRefresh) {
            var parsed = applyContainerHtml(sectionHtml, { loading: false });
            afterCart(cart, parsed.priceShippingBar);
            return cart;
          }

          if (quantity === 0) {
            if (sectionHtml) {
              applyContainerHtml(sectionHtml, { loading: false });
            } else {
              return self.refresh().then(function () {
                afterCart(cart);
                return cart;
              });
            }
            afterCart(cart);
            return cart;
          }

          if (sectionHtml) {
            patchTopBanners(sectionHtml);
          }

          updateLinePrice(cart, line);
          updateFooter(cart);
          shippingConfetti(cart);

          if (fullRefresh && !sectionHtml) {
            return self.refresh();
          }

          return cart;
        })
        .fail(function () {
          $row.removeClass('is-loading');
          self.setLoading(false);
        });
    },

    changeDebounced: function (line, quantity) {
      var self = this;
      clearTimeout(self._qtyTimer);
      self._qtyTimer = setTimeout(function () {
        self.change(line, quantity);
      }, qtyDebounceMs);
    },

    addWithSections: function (formData) {
      formData.append('sections', SECTION_ID);
      formData.append('sections_url', sectionsUrl());

      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      });
    }
  };

  window.CartDrawer = CartDrawer;

  window.loadMiniCart = function () {
    return CartDrawer.refresh();
  };

  $(function () {
    try {
      var stored = sessionStorage.getItem('modacan_cart_count');
      var $badge = $('[data-cart-count]').first();
      if (stored !== null && $badge.length && String($badge.text().trim()) === '0') {
        $('[data-cart-count]').html(stored);
      }
    } catch (e) {
      /* ignore */
    }
    CartDrawer.syncCount();
  });

  window.deferProductInventoryReload = function () {
    if (!$('.product-single .content-variant_inventory').length) return;
    var run = function () {
      $('.product-single .content-variant_inventory').load(
        window.location.href + ' .content-variant_inventory .js-product-avaiable'
      );
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(run, { timeout: 2000 });
    } else {
      setTimeout(run, 600);
    }
  };
})(window, jQuery);
